import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `chemical-type`);
        return response;
    } catch (e) { }
}

export async function chemicalTypeAdd(newDetails: any) {
    try {
        const response = await apiPost('core', `chemical-type`, newDetails);
        return response;
    } catch (e) { }
}

export async function chemicalTypeUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `chemical-type/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removeChemicalType(id: any) {
    try {

        return await apiDelete('core', `chemical-type/${id}`);
    } catch (e) { }
}